import { Calculated } from '@global/types'

const transformationFunctions = {
  split: transformSplitCalculation,
}

export function transformCalculatedField(fieldValue: string, calculatedField: Calculated): string {
  const transformationFunction = transformationFunctions[calculatedField.function]

  if (!transformationFunction) {
    return ''
  }

  if (!fieldValue) {
    return ''
  }

  return transformationFunction(fieldValue, calculatedField)
}

function transformSplitCalculation(fieldValue: string, calculatedField: Calculated): string {
  const [delimiter, index] = calculatedField.arguments

  if (!delimiter || !index || !fieldValue.includes(delimiter)) {
    return ''
  }

  const splitValues = fieldValue.split(delimiter)

  return splitValues[index]
}
